import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class PrintAuthTokenService {
	private token: string | null = null;

	setToken(token: string | null | undefined): void {
		this.token = token || null;
	}

	getToken(): string | null {
		return this.token;
	}

	clear(): void {
		this.token = null;
	}
}
